import React from 'react';

export const EASEBUZZ_LOGO_COLOR = require('../src/assets/images/eb-logo-color.png');

export const EASEBUZZ_PS_LOGO_COLOR = "https://ebz-static.s3.ap-south-1.amazonaws.com/logo/Easebuzz-Logo-Unit.svg";

export const EASEBUZZ_PS_LOGO_WHITE = "https://ebz-static.s3.ap-south-1.amazonaws.com/logo/Easebuzz-Logo-Unit+-White-Text.svg";

export const PAYMENT_PAGE_BG = require('../src/assets/images/ppbg.png');

export const YES_BANK_LOGO = require('../src/assets/images/yes-bank-logo.png');

export const RBL_BANK_LOGO = require('../src/assets/images/rbl-bank-logo.png');

export const ICICI_BANK_LOGO = require('../src/assets/images/icici-bank-logo.png');

export const IDFC_BANK_LOGO = require('../src/assets/images/idfc-bank-logo.png');
export const NSDL_BANK_LOGO = require('../src/assets/images/nsdl.png')
export const AXIS_BANK_LOGO = require('../src/assets/images/axis-bank-logo.png');
export const SLICE_BANK_LOGO = require('../src/assets/images/slice-bank-logo.png');
export const DBS_BANK_LOGO = require('../src/assets/images/dbs-bank-logo.jpg');

export const SBI_BANK_LOGO = require('../src/assets/images/sbi-bank-logo.png');

export const PGIcon = require("./assets/images/pg.svg");
export const PLIcon = require("./assets/images/pl.svg");
export const WireIcon = require("./assets/images/wire.svg");
export const TellerIcon = require("./assets/images/teller.svg");
export const InstaCollectIcon = require("./assets/images/instacollect.svg");
export const SmartBillingIcon = require("./assets/images/smartbilling.svg");
export const LoansIcon = require("./assets/images/loans.svg");
export const EduIcon = require('./assets/images/fees_enabled.svg');
export const AppStoreIcon = require('./assets/images/appstore.svg');
export const SettingsIcon = require("./assets/images/setting.svg");
export const LogoutIcon = require("./assets/images/logout.svg");
export const HelpIcon = require("./assets/images/help.svg");
export const SmartXIcon = require("./assets/images/smartx_enabled.svg");
export const VerificationSuiteIcon = require("./assets/images/verification_suite.svg");

export const chatIcon = require("./assets/images/chat.svg");
export const redirectIcon = require("./assets/images/redirect.svg");


export const disabledPGIcon = require("./assets/images/inactive/pg.svg");
export const disabledPLIcon = require("./assets/images/inactive/pl.svg");
export const disabledWireIcon = require("./assets/images/inactive/wire.svg");
export const disabledTellerIcon = require("./assets/images/inactive/teller.svg");
export const disabledInstaCollectIcon = require("./assets/images/inactive/instacollect.svg");
export const disabledSmartBillingIcon = require("./assets/images/inactive/smartbilling.svg");
export const disabledEduIcon = require('./assets/images/inactive/feesbuzz_disable.svg');
export const disabledLoansIcon = require("./assets/images/inactive/loans.svg");
export const disabledAppStoreIcon = require("./assets/images/inactive/appstore.svg");
export const disabledSmartXIcon = require("./assets/images/inactive/smartx_disabled.svg");
export const disabledVerificationSuiteIcon = require("./assets/images/inactive/verification_suite.svg");


export const PAYMENT_METHODS = [{
    payment_type: "bank_account",
    label: "IMPS",
    value: "IMPS",
    description: {
        amount: "Upto ₹1 lakh instantly",
        time: "Open 24 x 7 hours"
    }
}, {
    payment_type: "bank_account",
    label: "NEFT",
    value: "NEFT",
    description: {
        amount: "Any amount in 2 hours",
        time: "Only working hours"
    }
}, {
    payment_type: "bank_account",
    label: "RTGS",
    value: "RTGS",
    description: {
        amount: "Above ₹2 lakh in 30 mins",
        time: "Only working hours"
    }
}, {
    payment_type: "upi",
    label: "UPI",
    value: "UPI",
    description: {
        amount: "Upto ₹1 lakh, instant credit",
        time: "Open 24 x 7 hours"
    }
},{
    payment_type: "amazon_wallet",
    label: "Amazon Wallet",
    value: "AMAZON_WALLET",
    description: {
        amount: "Upto ₹1 lakh, instant credit",
        time: "Open 24 x 7 hours"
    }
}]
export const BUSINESS_ENTITY_TYPE = {
    0: {
        entity_type_label: "Individual/Freelancers"
    },
    4: {
        entity_type_label: "Society/Trust - Education"
    },
    5: {
        entity_type_label: "HUF (Hindu Undivided Family)"
    },
    7: {
        entity_type_label: "Limited Liability Partnership"
    },
    9: {
        entity_type_label: "Partnership Firm"
    },
    10: {
        entity_type_label: "Sole Proprietor"
    },
    11: {
        entity_type_label: "Private Ltd/Public Ltd/OPC"
    },
    12: {
        entity_type_label: "Trust/NGO - Donations"
    },
    13: {
        entity_type_label: "Government Entity"
    },
    14: {
        entity_type_label: "Co-operative Credit Society/JV/AOP"
    },

}

export const TALLY_INVOICE_STATUS_TYPES = {
    paid: {
        label: "Paid",
        color: "green",
        description: "Invoice is Paid.",
    },
    un_paid: {
        label: "Un-Paid",
        color: "blue",
        description: "Invoice is not Paid",
    },
}

export const VENDOR_APPROVAL_STATUS = {
    1: {
        label: "Active",
        color: "green",
        description: "Vendor is active and invoices can be uploaded against the vendor."
    },
    2: {
        label: "Unapproved",
        color: "yellow",
        description: "Vendor is unapproved and waiting for checker & approver to approve or reject the vendor."
    },
    3: {
        label: "Rejected",
        color: "red",
        description: "Vendor has been rejected by the checker or the approver. Invoices can not be uploaded against the vendor."
    },
    4: {
        label: "Deactivated",
        color: "red",
        description: "Vendor has been deactivated. Invoices can not be uploaded against the vendor."
    }
}

export const VENDOR_STATUS = {
    active: {
        label: "Active",
        color: "green",
        description: "Vendor is active and invoices can be uploaded against the vendor."
    },
    unapproved: {
        label: "Unapproved",
        color: "yellow",
        description: "Vendor is unapproved and waiting for checker & approver to approve or reject the vendor."
    },
    rejected: {
        label: "Rejected",
        color: "red",
        description: "Vendor has been rejected by the checker or the approver. Invoices can not be uploaded against the vendor."
    },
    deactivated: {
        label: "Deactivated",
        color: "red",
        description: "Vendor has been deactivated. Invoices can not be uploaded against the vendor."
    }
}


export const MAKER_ACTION_TYPE = {
    vendor_create: { "label": "Vendor Create" },
    invoice_create: { "label": "Invoice Create" },
}

export const APPROVAL_STATUS_TYPE = {
    checked: { "label": "Checked" },
    created: { "label": "Created" },
    approved: { "label": "Approved" },
    rejected: { "label": "Rejected" }
}

export const VENDOR_INVOICE_STATUS_TYPES = {
    cancelled: {
        value: 4,
        key: "cancelled",
        label: "Cancelled",
        color: "yellow",
        description: "Invoice has been cancelled manually by user. Invoice can not be processed further.",
    },
    processing: {
        value: 3,
        key: "processing",
        label: "Processing",
        color: "blue",
        description: "Invoice payment is in progress. Please wait for the final status.",
    },
    paid: {
        value: 2,
        key: "paid",
        label: "Paid",
        color: "green",
        description: "Invoice has been paid successfully.",
    },
    unpaid: {
        value: 1,
        key: "unpaid",
        label: "Unpaid",
        color: "red",
        description: "Invoice is yet to be paid.",
    },
    unapproved: {
        value: 5,
        key: "unapproved",
        label: "Unapproved",
        color: "yellow",
        description: "Invoice is unapproved.",
    },
    rejected: {
        value: 6,
        key: "rejected",
        label: "Rejected",
        color: "red",
        description: "Invoice is rejected.",
    },
}

export const BANK_ACCOUNT_VERIFICATION_STATUS = {
    pending: {
        label: "Pending",
        color: "yellow"
    },
    approved: {
        label: "Approved",
        color: "green"
    },
    rejected: {
        label: "Rejected",
        color: "red"
    }
  };

export const TRANSFER_STATUS_TYPES = {
    accepted: {
        label: "Accepted",
        color: "blue",
        description: "Transfer Request is sent to bank.",
    },
    queued: {
        label: "Queued",
        color: "blue",
        description: "Transfer Request will be accepted once sufficient amount of balance is available in your virtual account.",
    },
    cancelled: {
        label: "Cancelled",
        color: "red",
        description: "Transfer Request was cancelled by user while it was in Queued status.",
    },
    in_process: {
        label: "In Process",
        color: "blue",
        description: "Bank is processing your transfer request."
    },
    success: {
        label: "Success",
        color: "green",
        description: "Money is successfully credited to beneficiary account."
    },
    failure: {
        label: "Failure",
        color: "red",
        description: "Transfer request could not be processed due to any reason."
    },
    pending: {
        label: "Pending",
        color: "yellow",
        description: "Transfer request is accepted by easebuzz but yet not sent to bank."
    },
    on_hold: {
        label: "On Hold",
        color: "yellow",
        description: "Transfer request is put on hold due to any reason. Manual intervention required."
    },
    rejected: {
        label: "Rejected",
        color: "red",
        description: "Transfer request is rejected by beneficiary bank. Same as failure."
    },
    reversed: {
        label: "Reversed",
        color: "red",
        description: "Transfer request was successful but beneficiary bank made a reverse entry to your account."
    },
    unapproved: {
        label: "Unapproved",
        color: "yellow",
        description: "Transfer request is in approval flow."
    },
    scheduled: {
        label: "Scheduled",
        color: "blue",
        description: "Transfer request is scheduled."
    }
};

export const BATCH_STATUS_TYPES = {
    pending: {
        label: "Pending",
        color: "yellow"
    },
    processing: {
        label: "Processing",
        color: "blue"
    },
    completed: {
        label: "Completed",
        color: "green"
    },
    cancelled: {
        label: "Cancelled",
        color: "grey"
    },
    unapproved: {
        label: "Unapproved",
        color: "orange"
    }
};

export const BATCH_RECORD_STATUS_TYPES = {
    pending: {
        label: "Pending",
        color: "yellow"
    },
    processing: {
        label: "Processing",
        color: "blue"
    },
    completed: {
        label: "Completed",
        color: "green"
    },
    failed: {
        label: "Failed",
        color: "red"
    },
    cancelled: {
        label: "Cancelled",
        color: "grey"
    }
};

export const PROVIDER_PAYMENT_MODE_MESSAGES = {
    YESBANK: {
        NEFT: {
            message: "Working hours for NEFT are 8:00 am to 6:45 pm. Any transaction after 6:45 pm would be processed on next working day.",
            asset_link: "https://easewire.s3.ap-south-1.amazonaws.com/public/rtgs-holidays-2020.pdf",
            node: <span>
                Working hours for NEFT are 8:00 am to 6:45 pm. Any transaction after 6:45 pm would be processed on next working day. 
            </span>
        },
        RTGS: {
            message: "Working hours for RTGS are 8:00 am to 6:00 pm. Any transaction after 6:00 pm would be processed on next working day.",
            asset_link: "https://easewire.s3.ap-south-1.amazonaws.com/public/rtgs-holidays-2020.pdf",
            node: <span>
                Working hours for RTGS are 8:00 am to 6:00 pm. Any transaction after 6:00 pm would be processed on next working day. 
            </span>
        }
    },
    RBL: {
        NEFT: {
            message: "Working hours for NEFT are 8:00 am to 6:45 pm. Any transaction after 6:45 pm would be processed on next working day.",
            asset_link: "https://easewire.s3.ap-south-1.amazonaws.com/public/rtgs-holidays-2020.pdf",
            node: <span>
                Working hours for NEFT are 8:00 am to 6:45 pm. Any transaction after 6:45 pm would be processed on next working day. 
            </span>
        },
        RTGS: {
            message: "Working hours for RTGS are 8:00 am to 6:00 pm. Any transaction after 6:00 pm would be processed on next working day.",
            asset_link: "https://easewire.s3.ap-south-1.amazonaws.com/public/rtgs-holidays-2020.pdf",
            node: <span>
                Working hours for RTGS are 8:00 am to 6:00 pm. Any transaction after 6:00 pm would be processed on next working day. 
            </span>
        }
    },
    KOTAK: {
        NEFT: {
            message: "Working hours for NEFT are 8:00 am to 6:45 pm. Any transaction after 6:45 pm would be processed on next working day.",
            asset_link: "https://easewire.s3.ap-south-1.amazonaws.com/public/rtgs-holidays-2020.pdf",
            node: <span>
                Working hours for NEFT are 8:00 am to 6:45 pm. Any transaction after 6:45 pm would be processed on next working day. 
            </span>
        },
        RTGS: {
            message: "Working hours for RTGS are 8:00 am to 6:00 pm. Any transaction after 6:00 pm would be processed on next working day.",
            asset_link: "https://easewire.s3.ap-south-1.amazonaws.com/public/rtgs-holidays-2020.pdf",
            node: <span>
                Working hours for RTGS are 8:00 am to 6:00 pm. Any transaction after 6:00 pm would be processed on next working day. 
            </span>
        }
    },
    AIRTEL: {
        NEFT: {
            message: "Working hours for NEFT are 8:00 am to 6:45 pm. Any transaction after 6:45 pm would be processed on next working day.",
            asset_link: "https://easewire.s3.ap-south-1.amazonaws.com/public/rtgs-holidays-2020.pdf",
            node: <span>
                Working hours for NEFT are 8:00 am to 6:45 pm. Any transaction after 6:45 pm would be processed on next working day. 
            </span>
        },
        RTGS: {
            message: "Working hours for RTGS are 8:00 am to 6:00 pm. Any transaction after 6:00 pm would be processed on next working day.",
            asset_link: "https://easewire.s3.ap-south-1.amazonaws.com/public/rtgs-holidays-2020.pdf",
            node: <span>
                Working hours for RTGS are 8:00 am to 6:00 pm. Any transaction after 6:00 pm would be processed on next working day. 
            </span>
        }
    }
};


export const PERMISSION_CATEGORY = {
    DASHBOARD: "Dashboard",
    CONTACTS: "Contacts",
    TRANSFERS: "Transfers",
    ACCOUNT_STATEMENT: "Account statement",
    BULK_OPERATIONS: "Bulk operations",
    INVOICES: "Invoices",
    MERCHANTS: "Merchants",
    SETTINGS: "Settings",
    USERS: "Users",
    VIRTUAL_ACCOUNTS: 'Virtual Accounts',
    VERIFICATIONS: 'Verifications',
    REPORTS: 'Reports',
    PAYOUT_LINKS: 'Payout Links',
    INSTA_COLLECT: 'InstaCollect',
    APPROVAL_FLOW: 'Approval Flow',
    TAX_PAYMENTS: 'Tax Payments',
    VENDOR_PAYOUTS: 'Vendor Payouts',
    TALLY_INVOICES: 'Tally Invoices',
    WIRE_FUNDING_ACCOUNT:'Funding Accounts'
};

export const API_REQUESTS_STATUS_TYPES = {
    initiated: {
        label: "Initiated",
        color: "yellow",
        description: "Request has been sent to bank.",
    },
    failure: {
        label: "Failure",
        color: "red",
        description: "Request could not be processed.",
    },
    success: {
        label: "Success",
        color: "green",
        description: "Request successfully processed.",
    },
};

export const API_REQUESTS_TYPES = {
    PENNY_DROP_API: {
        label: "Penny Drop",
    },
    VPA_VERIFICATION_API: {
        label: "VPA Verification",
    },
    BANK_STATUS: {
        label: "Bank Status",
    },
    PENNY_DROP_FUZZY_API:{
        label: "Advanced Penny Drop (Name Comparison)"
    },
    IFSC_VERIFICATION:{
        label:"IFSC verification"
    },
    PAN_VERIFICATION:{
        label:"PAN verification"
    },
    GSTIN_VERIFICATION:{
        label:"GSTIN verification"
    },
    PENNYLESS_API:{
        label: "Pennyless verification"
    },
};

export const COMPARISON_VALIDITY_STATUS = {
    true: {
      label: "Successful",
      color: "green",
    },
    false: {
      label: "Failed",
      color: "red",
    },
  };

export const MONTH_MASTER = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
];

export const MERCHANT_REPORT_STATUS_TYPES = {
    no_data: {
        label: "No Data",
        color: "grey"
    },
    pending: {
        label: "Pending",
        color: "yellow"
    },
    in_process: {
        label: "In Process",
        color: "blue"
    },
    generated: {
        label: "Generated",
        color: "green"
    }
};

export const BANK_CODE = {
    YESBANK: "Yes Bank Virtual Account",
    RBL: "RBL Bank Virtual Account",
    ICICI: "ICICI Bank Virtual Account"
}
export const PAYOUT_LINK_STATUS_TYPES = {
    active: {
        label: "Active",
        color: "blue",
        description: "Payout Link is active and accessible for payee."
    },
    paid: {
        label: "Paid",
        color: "green",
        description: "Funds were transferred successfully."
    },
    expired: {
        label: "Expired",
        color: "grey",
        description: "Payout Link has crossed it's expiration date."
    },
    deactivated: {
        label: "Deactivated",
        color: "red",
        description: "Payout Link was either deactivated manually or maximum allowed attempts were exhausted by payee."
    }
};

export const BENEFICIARY_TYPE_MASTER = [
    { key: "bank_account", label: "Bank Account" },
    { key: "upi", label: "UPI" },
    { key: "imps", label: "IMPS" },
    { key: "neft", label: "NEFT" },
    { key: "rtgs", label: "RTGS" },
];

export const SMART_COLLECT_TRANSACTIONS_STATUS_TYPES = {
    pending: {
        label: "Pending",
        color: "yellow", //Color: Ocre
        description: "The transaction is pending at the bank's end and will get updated shortly.",
    },
    timed_out: {
        label: "Timed Out",
        color: "#ed927a",
        description: "The transaction was in pending status for long and hence has been 'Timed Out' by the bank.",
    },
    failure: {
        label: "Failure",
        color: "red",
        description: "The transaction was attempted by the remitter but failed at the bank.",
    },
    uncaptured: {
        label: "Uncaptured",
        color: "yellow",
        description: "The transaction is successful but is yet to be captured by the merchant.",
    },
    unsettled: {
        label: "Unsettled",
        color: "yellow",
        description: "The transaction is successful but has not been settled by the bank, or T+0 settlement is disabled for the merchant.",
    },
    received: {
        label: "Received",
        color: "green",
        description: "The merchant may initiate a settlement for this transaction or refund it back to the remitter.",
    },
    partially_refunded: {
        label: "Partially Refunded",
        color: "blue",
        description: "A part of the transaction's amount has been refunded to the remitter.",
    },
    refunded: {
        label: "Refunded",
        color: "#6f55c1",
        description: "The complete amount of the transaction has been refunded to the remitter.",
    }
}

export const SMART_COLLECT_TRANSACTION_ORDERS_STATUS_TYPES = {
    0: {
        label: "Created",
        color: "yellow",
        description: "Transaction order is unsettled.",
    },
    1: {
        label: "Partially Completed",
        color: "orange",
        description: "Transaction order partially completed.",
    },
    2: {
        label: "Completed",
        color: "green",
        description: "Transaction order completed successfully.",
    },
    3: {
        label: "Cancelled",
        color: "red",
        description: "Transaction order cancelled.",
    },
    4: {
        label: "Dropped",
        color: "red",
        description: "Failed transaction.",
    }
}
export const SMART_COLLECT_TRANSACTION_ORDERS_NOTIFICATION_CYCLE_TYPES = {
    daily: { label: "Daily" },
    weekly: { label: "Weekly" },
    monthly: { label: "Monthly" },
    yearly: { label: "Yearly" },
}

export const DISBURSEMENTS_STATUS_TYPES = {
    in_process: {
        label: "In Process",
        color: "blue",
        description: "Bank is processing your transfer request."
    },
    success: {
        label: "Success",
        color: "green",
        description: "Money is successfully credited to beneficiary account."
    },
    failure: {
        label: "Failure",
        color: "red",
        description: "Transfer request could not be processed due to any reason."
    },
    pending: {
        label: "Pending",
        color: "yellow",
        description: "Transfer request is accepted by easebuzz but yet not sent to bank."
    },
    reversed: {
        label: "Reversed",
        color: "red",
        description: "Transfer request was successful but beneficiary bank made a reverse entry to your account."
    },
    queued: {
        label: "Queued",
        color: "black",
        description: "Request is in queue and will be processed after applicable balance exists in the account."
    }
};

export const DISBURSEMENTS_TYPES = {
    settlement: {
        label: "Settlement",
        color: "blue",
    },
    refund: {
        label: "Refund",
        color: "volcano",
    },
    loan_repayment:{
        label: "Loan Repayment",
        color: "gold",
    },
    chargeback:{
        label: "Chargeback",
        color: "cyan",
    },
    hold:{
        label: "Hold",
        color: "orange",
    },
    other:{
        label: "Other",
        color: "grey",
    }
};

export const getBankLogo = (code) => {
    return {
      YESBANK: YES_BANK_LOGO,
      RBL: RBL_BANK_LOGO,
      ICICI: ICICI_BANK_LOGO,
      "YESBANK-BPE": YES_BANK_LOGO,
      IDFC: IDFC_BANK_LOGO,
      AXIS: AXIS_BANK_LOGO,
      SLICE: SLICE_BANK_LOGO,
      NSDL: NSDL_BANK_LOGO,
      DBS: DBS_BANK_LOGO,
      "SBI": SBI_BANK_LOGO
    }[code];
};

export const APPROVAL_FLOW_STATUS_TYPES = {
    unapproved: {
        label: "Unapproved",
        color: "red",
        description: "Transfer Request is not approved.",
    },
    approved: {
        label: "Approved",
        color: "green",
        description: "Transfer Request is approved and processed.",
    },
    partially_approved: {
        label: "Partially Approved",
        color: "yellow",
        description: "Transfer Request is partially aprroved.",
    },
    rejected: {
        label: "Rejected",
        color: "red",
        description: "Transfer request is rejected."
    },
    cancelled: {
        label: "Cancelled",
        color: "red",
        description: "Transfer request is cancelled."
    }
};

export const TDS_CATEGORIES = [
    { id: 1, percentage: 0, label: "No TDS (0%)" },
    { id: 2, percentage: 2, label: "194J(1) Fees for Technical Services (2%)" }
];

export const SPLIT_APPROVAL_STATUS_TYPES = {
    pending: {
        label: "Pending",
        color: "yellow",
    },
    approved: {
        label: "Approved",
        color: "green",
    },
    rejected: {
        label: "Rejected",
        color: "red",
    },
}

export const PAYMENT_MODES = {
    UPI: "UPI",
    NEFT: "NEFT",
    IMPS: "IMPS",
    RTGS: "RTGS",
    AMAZON_WALLET: "Amazon Wallet",
}

export const beneficiaryOrganisationTypes = [
  { label: "Partnership", value: "partnership" },
  { label: "Public Limited", value: "public_limited" },
  { label: "Private Limited", value: "private_limited" },
  { label: "Sole Proprietorship", value: "sole_proprietorship" },
  { label: "Society", value: "society" },
  { label: "Trust", value: "trust" },
  { label: "Government Entity", value: "government_entity" },
];
